import script from "./EditHeaderEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditHeaderEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditHeaderEvent.vue?vue&type=style&index=0&id=0701c6ac&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0701c6ac"]])

export default __exports__